/**
 * I got this list from Hagedorn. Specialty categoryUrls where the specialty
 * is not deleted and is marked as "seoAvailable".
 */
const specialtyPathPrefixes = [
    '/acupuncturists',
    '/allergists',
    '/audiologists',
    '/cardiologists',
    '/chiropractors',
    '/dentists',
    '/dermatologists',
    '/dietitians',
    '/ear-nose-throat-doctors',
    '/emergency-medicine-physicians',
    '/endocrinologists',
    '/endodontists',
    '/eye-doctors',
    '/family-physicians',
    '/gastroenterologists',
    '/hand-surgeons',
    '/hearing-specialist',
    '/hematologists',
    '/infectious-disease-specialists',
    '/infertility-specialists',
    '/internists',
    '/naturopathic-doctors',
    '/nephrologists',
    '/neurologists',
    '/neurosurgeons',
    '/nurse-practitioners',
    '/nutritionists',
    '/obgyns',
    '/oncologists',
    '/ophthalmologists',
    '/optometrists',
    '/oral-surgeons',
    '/orthodontists',
    '/orthopedic-surgeons',
    '/pain-management-specialists',
    '/pediatric-dentists',
    '/pediatric-urgent-care-specialists',
    '/pediatricians',
    '/periodontists',
    '/physiatrists',
    '/physical-therapists',
    '/plastic-surgeons',
    '/podiatrists',
    '/primary-care-doctors',
    '/prosthodontists',
    '/psychiatrists',
    '/psychologists',
    '/psychotherapists',
    '/pulmonologists',
    '/radiologists',
    '/rheumatologists',
    '/sleep-medicine-specialists',
    '/sports-medicine-specialists',
    '/surgeons',
    '/therapist-counselors',
    '/travel-medicine-specialists',
    '/urgent-care-specialists',
    '/urologists',
];

const spanishSpecialtyPrefixes = [
    'acupunturistas',
    'alergista',
    'audiólogos',
    'cardiólogos',
    'cirujanos',
    'cirujanos-de-las-manos',
    'cirujanos-orales',
    'cirujanos-ortopédicos',
    'cirujanos-plásticos',
    'dentistas',
    'dentistas-pediátricos',
    'dermatólogos',
    'dietista',
    'doctores-de-ojos',
    'endocrinólogos',
    'endodoncistas',
    'enfermeras-profesionales',
    'especialista-en-infertilidad',
    'especialistas-en-audición',
    'especialistas-enfermedades-infecciosas',
    'especialistas-manejo-dolor',
    'especialistas-medicina-del-sueño',
    'especialistas-medicina-deporte',
    'especialistas-medicina-viajes',
    'especialistas-pediátricos-de-urgencia',
    'fisiatras',
    'gastroenterólogos',
    'ginecologo-obstetra',
    'hematólogos',
    'internistas',
    'los-especialistas-de-atención-de-urgencia',
    'médicos-atención-primaria',
    'médicos-de-emergencia',
    'médicos-familiares',
    'naturópatas',
    'nefrólogos',
    'neumólogos',
    'neurocirujanos',
    'neurólogos',
    'nutricionistas',
    'oftalmólogos',
    'oncólogos',
    'optometras',
    'ortodoncistas',
    'otorrinolaringólogos',
    'pediatras',
    'periodoncistas',
    'podiatras',
    'prostodoncistas',
    'psicólogos',
    'psicoterapeuta',
    'psiquiatras',
    'quiroprácticos',
    'radiologos',
    'reumatólogos',
    'terapeutas-consejeros',
    'terapeutas-físicos',
    'urólogos',
].map(encodeURIComponent).map(s => `/${s}`);

const reactRouterifiedSpecialtyPathPrefixes = specialtyPathPrefixes
    .concat(spanishSpecialtyPrefixes)
    .map(x => `${x}(/:threat2)(/:threat3)`);

const procedurePathPrefixes = [
    '/procedure',
];

const reactRouterifiedProcedurePathPrefixes = procedurePathPrefixes.map(x => `${x}/:procedureType`);

const languagePathPrefixes = [
    '/languages',
];

const reactRouterifiedLanguagePathPrefixes = languagePathPrefixes.map(x => `${x}/:language/:specialty`);

const seoRoutes = [
    ...specialtyPathPrefixes,
    ...spanishSpecialtyPrefixes,
    ...procedurePathPrefixes,
    ...languagePathPrefixes,
];

const seoRouteMatches = [
    ...reactRouterifiedProcedurePathPrefixes,
    ...reactRouterifiedSpecialtyPathPrefixes,
    ...reactRouterifiedLanguagePathPrefixes,
];

export {
    seoRouteMatches as default,
    seoRoutes,
};
